export default __webpack_public_path__ + "static/media/7 CCI Var - SansBaseline - bleuCMJN.5c008bbf.png";